import api from '@/api';
import {
  AccountInstallmentReceivableObservationRequest,
  AccountReceivableObservation,
  AccountReceivableObservationRequest,
  AccountReceivableObservationUpdateRequest,
} from './AccountReceivableObservation.types';

import { API_BASE_URL } from '..';
const baseUrl = `${API_BASE_URL}/AccountReceivableObservation`;

export async function accountReceivableObservationCreate(
  obj: AccountReceivableObservationRequest,
) {
  const result = (await api.post(baseUrl, obj, null)) as unknown;

  return result as AccountReceivableObservation;
}

export async function accountReceivableObservationList(
  obj: AccountInstallmentReceivableObservationRequest,
) {
  const result = (await api.get(baseUrl, obj)) as unknown;

  return result as AccountReceivableObservation[];
}

export async function accountReceivableObservationUpdate(
  obj: AccountReceivableObservationUpdateRequest,
) {
  const result = (await api.put(baseUrl, obj, null)) as unknown;

  return result;
}

export async function accountReceivableObservationDelete(id: number) {
  const result = (await api.remove(`${baseUrl}/${id}`, {}, null)) as unknown;

  return result;
}
